import { IonIcon, IonLabel } from '@ionic/react';
import { chevronForwardOutline } from 'ionicons/icons';
import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from '../../components/globals/Modal';
import { ChecklistService } from '../../services/ChecklistService';
import { AppContext } from '../../state/AppContextProvider';
import CheckList from '../checklist/CheckList';

export const MyChecklists = () => {
  const { state } = useContext(AppContext);

  const nbUnreadChecklists = ChecklistService.countChecklistTodo(
    state.allChecklists,
    state.allChecklistsEntries
  );

  return (
    <Modal
      content={<ChecklistsModaleContent />}
      ModalUrl={'/profile/checklists'}
      backUrl={'/profile'}
      hideCloseBtn={window.innerWidth > 768}
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center text-black">
          <div className="relative">
            <div className="flex w-8 h-8 mr-4 inset-4 justify-center items-center border border-transparent rounded-full text-white bg-primary ">
              <IonIcon icon="./assets/nav/checklists.svg" />
            </div>
            {nbUnreadChecklists > 0 && (
              <div className="absolute -top-1 right-3 bg-redNotif z-10 rounded-full text-center text-2xs text-white w-4 h-4">
                <span className="pb-1">{nbUnreadChecklists}</span>
              </div>
            )}
          </div>
          <IonLabel className="font-medium text-sm ">
            <FormattedMessage id="My checklists" />
          </IonLabel>
        </div>
        <IonIcon icon={chevronForwardOutline} />
      </div>
    </Modal>
  );
};

const ChecklistsModaleContent = () => {
  const { state } = useContext(AppContext);

  const list = state.allChecklists
    .map((checklist, i) => {
      const checklist_entry = ChecklistService.getEntry(
        checklist.id,
        state.allChecklistsEntries
      );
      if (
        checklist_entry &&
        checklist_entry.acf.entry_checklist_post_id !== checklist.id
      ) {
        console.warn('Bad entry found for ' + checklist.id, checklist_entry);
      }
      return {
        checklist: checklist,
        checklist_entry: checklist_entry,
      };
    })
    .filter((it) => it.checklist_entry !== null);

  const todoList = list.filter(
    (it) =>
      it.checklist_entry &&
      !ChecklistService.isDone(it.checklist, it.checklist_entry)
  );

  const doneList = list.filter(
    (it) =>
      it.checklist_entry &&
      ChecklistService.isDone(it.checklist, it.checklist_entry)
  );

  return (
    <div className="rounded-t-3xl bg-white modal-profile-content py-20 px-6 md:rounded-3xl">
      <div className="profile-header center flex flex-col items-center">
        <h2 className="font-semibold text-xl mt-4 text-black mb-8">
          <FormattedMessage id="Todo Checklists" />
        </h2>
        <div className="xl:grid xl:grid-cols-2 xl:gap-4 w-full">
          {state.isChecklistsFetch &&
            todoList.map(
              (it, i) =>
                it.checklist &&
                it.checklist_entry && (
                  <CheckList
                    key={it.checklist.id}
                    redirectionDisplay={false}
                    paddingBottom={true}
                    alignTextLeft={false}
                    checklist={it.checklist}
                    checklist_entry={it.checklist_entry}
                    heightFull={false}
                  />
                )
            )}
        </div>
        {state.isChecklistsFetch && todoList.length === 0 && (
          <div className="text-center w-full text-black">
            <p>
              <FormattedMessage id="No checklist" />
            </p>
          </div>
        )}
        <h2 className="font-semibold text-xl mt-12 text-black mb-8">
          <FormattedMessage id="Done Checklists" />
        </h2>
        <div className="xl:grid xl:grid-cols-2 xl:gap-4 w-full">
          {state.isChecklistsFetch &&
            doneList.map(
              (it, i) =>
                it.checklist &&
                it.checklist_entry && (
                  <CheckList
                    key={it.checklist.id}
                    redirectionDisplay={false}
                    paddingBottom={true}
                    alignTextLeft={false}
                    checklist={it.checklist}
                    checklist_entry={it.checklist_entry}
                    heightFull={false}
                  />
                )
            )}
        </div>
        {state.isChecklistsFetch && doneList.length === 0 && (
          <div className="text-center w-full text-black">
            <p>
              <FormattedMessage id="No checklist" />
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
